// src/locales/en/forms.js
export const forms = {
    emailRequired: "மின்னஞ்சல் தேவை",
    passwordRequired: "கடவுச்சொல் தேவை",
    nameRequired: "பெயர் தேவை",
    invalidEmail: "தயவுசெய்து சரியான மின்னஞ்சலை உள்ளிடுங்கள்",
    fieldRequired: "இந்த புலம் தேவை",
    savingChanges: "மாற்றங்கள் சேமிக்கப்படுகின்றன...",
    changesSaved: "மாற்றங்கள் வெற்றிகரமாக சேமிக்கப்பட்டன",
    errorSaving: "மாற்றங்களைச் சேமிப்பதில் பிழை"
}